"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = exports.Notification = void 0;
var tslib_1 = require("tslib");
var Notification_1 = require("@reactionable/core/lib/ui/notification/Notification");
var react_1 = tslib_1.__importDefault(require("react"));
var Toast_1 = tslib_1.__importDefault(require("react-bootstrap/Toast"));
exports.Notification = function (props) {
    return (react_1.default.createElement(Toast_1.default, { show: true, autohide: true, onClose: props.onClose, style: {
            position: 'fixed',
            top: '1vw',
            right: '1vw',
            zIndex: 9999,
        }, className: props.variant ? 'border-' + props.variant : '' },
        react_1.default.createElement(Toast_1.default.Header, { className: props.variant ? 'text-' + props.variant : '' },
            react_1.default.createElement("strong", { className: "mr-auto" }, props.title)),
        react_1.default.createElement(Toast_1.default.Body, null, props.children)));
};
exports.useNotification = function (props) {
    return Notification_1.useNotification(tslib_1.__assign(tslib_1.__assign({}, props), { Component: exports.Notification }));
};
//# sourceMappingURL=Notification.js.map